// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Mobile2OutlinedSvg from "@fishx/icons-svg/es/asn/Mobile2Outlined";
import FishxIcon from '../components/FishxIcon';

var Mobile2Outlined = function Mobile2Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Mobile2OutlinedSvg
  }));
};

Mobile2Outlined.displayName = 'Mobile2Outlined';
export default React.forwardRef(Mobile2Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Mobile2Outlined.js
// module id = 3152
// module chunks = 0